// Import model
import { UpdatePhoneNumberRequest } from '../models/UpdatePhoneNumberRequest';

// Import base class serializer

// Import dependency types (models and enums used in properties)

// Import dependency serializers (for complex types)

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for UpdatePhoneNumberRequest - handles JSON serialization and deserialization with type validation
 */
export class UpdatePhoneNumberRequestSerializer {
  /**
   * Deserializes a JSON string into a UpdatePhoneNumberRequest instance
   */
  static deserialize(json: string): UpdatePhoneNumberRequest {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a UpdatePhoneNumberRequest instance
   */
  static fromObject(obj: any): UpdatePhoneNumberRequest {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to UpdatePhoneNumberRequest');
    }


    const instance: UpdatePhoneNumberRequest = {
      description: obj['description'] as string | undefined,
      phoneNumber: obj['phoneNumber'] as string | undefined,
      type_: obj['type'] as string | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of UpdatePhoneNumberRequest instances
   */
  static deserializeArray(json: string): UpdatePhoneNumberRequest[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a UpdatePhoneNumberRequest instance to a JSON string
   */
  static serialize(instance: UpdatePhoneNumberRequest): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a UpdatePhoneNumberRequest instance to a plain object
   */
  static toObject(instance: UpdatePhoneNumberRequest): any {
    return {
      'description': instance.description,
      'phoneNumber': instance.phoneNumber,
      'type': instance.type_,
    };
  }

  /**
   * Serializes an array of UpdatePhoneNumberRequest instances to a JSON string
   */
  static serializeArray(instances: UpdatePhoneNumberRequest[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
